'use strict';
/* COMPONENT - c.06.02 - shop list */

export default class Listing {

    constructor(element, onMobile = false) {
        this.root = element;
        this.result = this.root.querySelectorAll('.js-listing-result');
        this.windowWidth = document.body.clientWidth;
        this.resizeEvent;
        this.resizeListener();
        this.bindEvents();
        this.onMobile = onMobile;
    }

    listingClick(el, e) {
        if (this.windowWidth > 768 || this.onMobile) {
            let a = el.querySelector('.js-listing-link').getElementsByTagName('a')[0],
                url = a.getAttribute('href');
            if (a.classList.contains('external')) {
                e.preventDefault();
                window.open(url);
            } else {
                window.location.href = url;
            }
        }
    }

    resizeTimer() {
        clearTimeout(this.resizeEvent);
        this.resizeEvent = setTimeout(this.updateWidth.bind(this), 100);
    }

    updateWidth() {
        this.windowWidth = document.body.clientWidth;
    }

    resizeListener() {
        window.addEventListener('resize', this.resizeTimer.bind(this));
    }

    bindEvents() {
        for (let i = 0; i < this.result.length; i++) {
            this.clickListener = this.listingClick.bind(this, this.result[i]);
            this.result[i].addEventListener('click', this.clickListener);
        }
    }
}
